import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Inbox } from "lucide-react";
import { api } from "@/lib/api";

// Header link to the My Notes inbox with an open-item count badge.
export function MyNotesLink() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(0);

  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/notes/inbox/count"); setOpen(data.open || 0); }
    catch { /* silent */ }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 60000);
    const onChange = () => refresh();
    window.addEventListener("mh:notes-changed", onChange);
    return () => { clearInterval(t); window.removeEventListener("mh:notes-changed", onChange); };
  }, [refresh]);

  return (
    <button
      data-testid="my-notes-link"
      onClick={() => navigate("/my-notes")}
      title="My Notes"
      className="relative flex items-center justify-center h-[34px] w-[34px] text-zinc-400 hover:text-indigo-300 border border-zinc-800 hover:border-zinc-700 rounded-lg transition-colors"
    >
      <Inbox className="h-4 w-4" />
      {open > 0 && (
        <span data-testid="my-notes-badge"
          className="absolute -top-1.5 -right-1.5 min-w-[16px] h-[16px] px-1 rounded-full bg-amber-500 text-zinc-950 text-[10px] font-bold flex items-center justify-center">
          {open > 9 ? "9+" : open}
        </span>
      )}
    </button>
  );
}
